/* Silk Cart Gift Card - in-cart UI behavior (v2: client-side state toggle for Edit)
 * Pairs with snippets/silk-cart-gift-card.liquid (which renders BOTH picker and added view when card is in cart).
 * Edit no longer removes the cart line - just toggles the picker visible with pre-populated values.
 * Save (confirm in edit mode) calls /cart/change.js + /cart/add.js to swap line.
 */
(function () {
  if (window.__silkGiftCardBound) return;
  window.__silkGiftCardBound = true;

  function getRoot(el) { return el ? el.closest('[data-silk-gc]') : null; }

  function resetPicker(root) {
    if (!root) return;
    root.querySelectorAll('[data-silk-gc-variant]').forEach(function (b) {
      b.classList.remove('is-selected');
    });
    var form = root.querySelector('[data-silk-gc-form]');
    if (form) form.hidden = true;
    var ta = root.querySelector('[data-silk-gc-textarea]');
    if (ta) ta.value = '';
    var counter = root.querySelector('[data-silk-gc-counter]');
    if (counter) counter.textContent = '0';
    var confirmBtn = root.querySelector('[data-silk-gc-confirm]');
    if (confirmBtn) {
      confirmBtn.disabled = true;
      delete confirmBtn.dataset.variantGid;
      confirmBtn.textContent = confirmBtn.dataset.labelAdd || 'הוספה לעגלה';
    }
    var picker = root.querySelector('[data-silk-gc-picker]');
    if (picker) {
      delete picker.dataset.editMode;
      delete picker.dataset.editLineKey;
    }
  }

  function refreshSnippetFromPage() {
    // Fetch the current page to get the freshly-rendered snippet with new cart state.
    return fetch(window.location.pathname + window.location.search, { cache: 'no-store' })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html) return;
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-silk-gc]');
        document.querySelectorAll('[data-silk-gc]').forEach(function (live) {
          if (!fresh) {
            if (live.parentNode) live.parentNode.removeChild(live);
          } else {
            live.outerHTML = fresh.outerHTML;
          }
        });
      })
      .catch(function (err) { console.error('[silk-gc] snippet refresh error', err); });
  }

  function notifyThemeCart() {
    document.querySelectorAll('cart-items').forEach(function (el) {
      if (typeof el.refresh === 'function') {
        try { el.refresh(); } catch (e) {}
      }
    });
    ['cart:refresh', 'cart:updated', 'cart:change'].forEach(function (evt) {
      document.dispatchEvent(new CustomEvent(evt));
    });
  }

  document.addEventListener('click', function (e) {
    var root;

    // 1) Variant selected (in picker)
    var variantBtn = e.target.closest('[data-silk-gc-variant]');
    if (variantBtn) {
      e.preventDefault();
      root = getRoot(variantBtn);
      if (!root) return;
      root.querySelectorAll('[data-silk-gc-variant]').forEach(function (b) {
        b.classList.remove('is-selected');
      });
      variantBtn.classList.add('is-selected');
      var form = root.querySelector('[data-silk-gc-form]');
      if (form) form.hidden = false;
      var confirmBtn = root.querySelector('[data-silk-gc-confirm]');
      if (confirmBtn) {
        confirmBtn.disabled = false;
        confirmBtn.dataset.variantGid = variantBtn.dataset.silkGcVariant;
      }
      var ta = root.querySelector('[data-silk-gc-textarea]');
      if (ta) {
        setTimeout(function () { try { ta.focus(); } catch (_) {} }, 80);
      }
      return;
    }

    // 2) Confirm (add new, or save edit)
    var confirmBtn = e.target.closest('[data-silk-gc-confirm]');
    if (confirmBtn) {
      e.preventDefault();
      if (confirmBtn.disabled) return;
      root = getRoot(confirmBtn);
      if (!root) return;
      var picker = root.querySelector('[data-silk-gc-picker]');
      var isEdit = picker && picker.dataset.editMode === '1';
      var editLineKey = picker ? picker.dataset.editLineKey : null;
      var ta = root.querySelector('[data-silk-gc-textarea]');
      var msg = ta ? (ta.value || '').trim() : '';
      var variantGid = confirmBtn.dataset.variantGid || '';
      var variantId = parseInt(variantGid.split('/').pop(), 10);
      if (!variantId) return;

      var origLabel = confirmBtn.textContent;
      confirmBtn.disabled = true;
      confirmBtn.textContent = isEdit ? 'שומרת...' : 'מוסיפה...';
      var props = msg ? { 'הודעה לכרטיס': msg } : {};

      var chain;
      if (isEdit && editLineKey) {
        // Edit: remove old line first, then add new with updated values
        chain = fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: editLineKey, quantity: 0 })
        })
          .then(function (r) { if (!r.ok) throw new Error('change failed: ' + r.status); return r.json(); })
          .then(function () {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: props }] })
            });
          });
      } else {
        chain = fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: props }] })
        });
      }

      chain
        .then(function (r) { if (!r.ok) throw new Error('add failed: ' + r.status); return r.json(); })
        .then(function () {
          notifyThemeCart();
          return refreshSnippetFromPage();
        })
        .catch(function (err) {
          console.error('[silk-gc] confirm error', err);
          confirmBtn.disabled = false;
          confirmBtn.textContent = origLabel;
          alert('שגיאה בשמירת הכרטיס. נסי שוב.');
        });
      return;
    }

    // 3) Cancel
    var cancelBtn = e.target.closest('[data-silk-gc-cancel]');
    if (cancelBtn) {
      e.preventDefault();
      root = getRoot(cancelBtn);
      if (!root) return;
      var pickerC = root.querySelector('[data-silk-gc-picker]');
      var addedC = root.querySelector('[data-silk-gc-added]');
      var wasEdit = pickerC && pickerC.dataset.editMode === '1';
      resetPicker(root);
      if (wasEdit && addedC && pickerC) {
        addedC.hidden = false;
        pickerC.hidden = true;
      }
      return;
    }

    // 4) Edit - toggle to picker, pre-populate. NO cart removal.
    var editBtn = e.target.closest('[data-silk-gc-edit]');
    if (editBtn) {
      e.preventDefault();
      root = getRoot(editBtn);
      if (!root) return;
      var added = root.querySelector('[data-silk-gc-added]');
      var pickerE = root.querySelector('[data-silk-gc-picker]');
      if (!added || !pickerE) return;
      var lineKey = added.dataset.lineKey || '';
      var prevVar = added.dataset.currentVariant || '';
      var prevMsg = added.dataset.currentMessage || '';

      pickerE.dataset.editMode = '1';
      pickerE.dataset.editLineKey = lineKey;
      added.hidden = true;
      pickerE.hidden = false;

      var cBtn = pickerE.querySelector('[data-silk-gc-confirm]');
      if (cBtn) {
        cBtn.textContent = cBtn.dataset.labelSave || 'שמירת שינויים';
      }

      // Pre-select variant (programmatic click reuses the variant handler above)
      if (prevVar) {
        var prevBtn = pickerE.querySelector('[data-silk-gc-variant="' + prevVar + '"]');
        if (prevBtn) prevBtn.click();
      }

      // Pre-fill textarea
      setTimeout(function () {
        var ta = pickerE.querySelector('[data-silk-gc-textarea]');
        if (ta) {
          ta.value = prevMsg;
          ta.dispatchEvent(new Event('input'));
        }
      }, 60);
      return;
    }
  });

  // Character counter (delegated)
  document.addEventListener('input', function (e) {
    var ta = e.target.closest('[data-silk-gc-textarea]');
    if (!ta) return;
    var root = ta.closest('[data-silk-gc]');
    if (!root) return;
    var counter = root.querySelector('[data-silk-gc-counter]');
    if (counter) counter.textContent = ta.value.length;
  });
})();
